import { Children, isValidElement, useMemo } from 'react';
import { ListboxItem } from './ListboxItem';
import { TActionsMap } from '@apia/dom-store';
import { TListboxState } from './common';
import { operations } from './operations';

export function useUpdateRowCount(
  children: React.ReactNode | React.ReactNode[],
  listboxActions: TActionsMap<TListboxState, typeof operations>,
) {
  useMemo(
    function updateRowCount() {
      let count = 0;
      Children.forEach(children, (current) => {
        if (isValidElement(current) && current.type === ListboxItem) count++;
      });
      listboxActions.setState({ rowsCount: count, affectedKeys: [] });
    },
    [listboxActions, children],
  );
}
